import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContentText, DialogButton, DialogActions } from '@engyalo/design-system';
import { ReactElement } from 'react';

export interface DialogConfirmationProps {
  open: boolean;
  title?: string;
  description?: ReactElement | string;
  disabled?: boolean;
  confirmText?: string;
  cancelText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const DialogConfirmation = ({
  open,
  title,
  description,
  disabled,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
}: DialogConfirmationProps) => {
  const { t } = useTranslation();
  const onCloseAction = disabled ? undefined : onCancel || onConfirm;
  const showCancelButton = !!onCancel;
  const showConfirmButton = !!onConfirm;
  const showActions = showCancelButton || showConfirmButton;
  const showDescription = !!description;

  const descriptionContent = typeof description === 'string' ? t(description) : description;

  return (
    <Dialog onClose={onCloseAction} variant="info" open={open}>
      <DialogTitle>
        {title}
        {showDescription && <DialogContentText>{descriptionContent}</DialogContentText>}
      </DialogTitle>
      {showActions && (
        <DialogActions>
          {showCancelButton && (
            <DialogButton onClick={onCancel} disabled={disabled}>
              {cancelText || t('confirmationDialog.cancel')}
            </DialogButton>
          )}
          {showConfirmButton && (
            <DialogButton onClick={onConfirm} primary disabled={disabled}>
              {confirmText || t('confirmationDialog.confirm')}
            </DialogButton>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogConfirmation;
